import { TranslateLoader, type TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { SUPPORTED_LOCALES, type Locale } from '../constants/locale.constants';

import en from '../../../assets/i18n/en.json';
import it from '../../../assets/i18n/it.json';
import es from '../../../assets/i18n/es.json';
import fr from '../../../assets/i18n/fr.json';

const translations: Record<Locale, TranslationObject> = {
  en: en as TranslationObject,
  it: it as TranslationObject,
  es: es as TranslationObject,
  fr: fr as TranslationObject,
};

/**
 * Loader that returns translations from static imports (no HTTP).
 * Fallback to 'en' if the requested locale is not supported.
 */
export class TranslateStaticLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<TranslationObject> {
    const locale = SUPPORTED_LOCALES.includes(lang as Locale) ? (lang as Locale) : 'en';
    return of(translations[locale] ?? translations.en);
  }
}
